import { useCallback, useContext } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';

import { AppContext } from '../AppContext';

export function useResetAppState(): () => void {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useResetAppState() must be used within an AppContextProvider');
  }

  const { setFeatures, setFilterFeatures, setSortFeaturesBy } = context;

  const reset = useCallback(() => {
    setFeatures([]);
    setFilterFeatures([]);
    setSortFeaturesBy('id');
    queryClient.removeQueries();
    navigate('/');
  }, [setFeatures, setFilterFeatures, setSortFeaturesBy, queryClient, navigate]);

  return reset;
}
